export default "/images/circ-galka.svg?4b56d5560bd8d6c4b55d87265a932360";